import { useScrollToTop } from '@mds/shared/hooks/use-scroll-to-top';

import AppRoutes from './routes/app-routes';

/** The route table lives in `routes/app-routes.tsx`. */
export default function App() {
  useScrollToTop();
  return <AppRoutes />;
}
